module.exports = __webpack_public_path__ + "themes/mf/font/proximasoft-regular-webfont.ttf";


//////////////////
// WEBPACK FOOTER
// ./themes/mf/font/proximasoft-regular-webfont.ttf
// module id = 144
// module chunks = 3